<template>
    <div class='page'>
        <!-- 搜索 -->
        <el-form
            v-if='isSearch'
            :model='queryForm'
            ref='form'
            label-width='80px'
            :inline='true'
            size='small'
            class='query-form'
            @submit.native.prevent
        >
            <el-form-item label='商品名称'>
                <el-input v-model='queryForm.productName' size='small' style='width: 200px'
                          placeholder='请输入商品名称'></el-input>
            </el-form-item>
            <el-form-item label='商品货号'>
                <el-input v-model='queryForm.productNumber' size='small' style='width: 200px'
                          placeholder='请输入商品货号'></el-input>
            </el-form-item>
            <el-form-item label='商品分类'>
                <el-select
                    style='width: 200px'
                    v-model='queryForm.categoryId'
                    placeholder='请选择'
                    clearable
                    size='small'
                    class='selectInput'
                >
                    <el-tree default-expand-all :data='shopProductCategoryList' :props='treeProps'>
                        <div class='custom-tree-node flex items-center' slot-scope='{ node, data }'>
                            <el-option :label='node.label' :value='data.id'></el-option>
                        </div>
                    </el-tree>
                </el-select>
            </el-form-item>

            <el-form-item label='商品类型'>
                <el-select
                    style='width: 200px'
                    v-model='queryForm.productType'
                    placeholder='请选择'
                    clearable
                    size='small'
                    class='selectInput'
                >
                    <el-option v-for='item in productTypeEnumList' :key='item.key' :label='item.value'
                               :value='item.key'></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label='是否上架'>
                <el-select class='selectInput' v-model='queryForm.isShow' size='small' placeholder='请选择' clearable
                           style='width: 200px'>
                    <el-option v-for='item in productStatusEnumList' :key='item.key' :label='item.value'
                               :value='item.key'></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label='销售价格'>
                <el-input v-model='queryForm.miniShopPrice' size='small' style='width: 200px'
                          placeholder='请输入最小价格'></el-input
                >
                <br />
                <el-input v-model='queryForm.maxShopPrice' size='small' style='width: 200px'
                          placeholder='请输入最大价格'></el-input>
            </el-form-item>

            <el-form-item label='商品库存'>
                <el-input v-model='queryForm.miniStock' size='small' style='width: 200px'
                          placeholder='请输入最小库存'></el-input
                >
                <br />
                <el-input v-model='queryForm.maxStock' size='small' style='width: 200px'
                          placeholder='请输入最大库存'></el-input>
            </el-form-item>
            <el-form-item v-if='showShop' label='所属店铺'>
                <GridSelectShop
                    style='width: 200px'
                    title='选择所属店铺'
                    labelName='shopName'
                    labelValue='id'
                    :value='queryForm.shopId'
                    :limit='1'
                    size='small'
                    @getValue='getValueShopId'
                    :columns="SHOP_code"
                    :searchs="SHOP_search"
                    dataListUrl='/mall/shop/findList'
                    entityBeanName='mallShop'
                    queryEntityUrl='/mall/shop/get'
                >
                </GridSelectShop>
            </el-form-item>
            <el-form-item label='商品定位'>
                <el-select
                    placeholder='请选择商品定位'
                    clearable
                    style='width: 200px'
                    size='small'
                    v-model='queryForm.productPosition'
                >
                    <el-option v-for='item in productPositionList' :key='item.key' :label='item.value' :value='item.key'></el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button size='small' type='primary' icon='el-icon-search' @click='getShopProductList'>查询
                </el-button>
                <el-button size='small' icon='el-icon-refresh' @click='resetQueryForm()'>重置</el-button>
            </el-form-item>
        </el-form>
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'>
                    <!-- <el-button type="primary" size="small" icon="el-icon-plus" @click="addShopProduct">新建</el-button> -->
                    <!-- <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editShopProduct(null)"
                        >修改</el-button
                    > -->
                    <el-button
                        type='danger'
                        plain
                        size='small'
                        icon='el-icon-delete'
                        :disabled='multipleSelection.length <= 0'
                        @click='deleteShopProduct(null)'
                    >删除
                    </el-button>

                    <el-select class='selectInput' v-model='status' size='small' placeholder='请选择' clearable
                               style='width: 177px;margin: 0 10px'>
                        <el-option v-for='item in productStatusEnumList' :key='item.key' :label='item.value'
                                   :value='item.key'></el-option>
                    </el-select>
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length <= 0 || status === ''"
                        @click="editShopProductStatus()"
                        >批量操作</el-button>

                    <el-button
                        type="primary"
                        plain
                        size="small"
                        icon="el-icon-upload2"
                        @click="handleImportDialog()"
                    >
                        导入供应链商品
                    </el-button>

                    <el-button
                        type="primary"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        @click="handleBatchEditDialog()"
                    >
                        批量修改
                    </el-button>
                </div>

                <div class='icon-group'>
                    <span title='搜索' class='icon-box' @click='search'>
                        <Icon color='#606266'>
                            <Search />
                        </Icon>
                    </span>
                    <!-- <span title="导出数据" class="icon-box" @click="exportShopProductList">
                        <Icon color="#606266">
                            <ArrowDownload24Regular />
                        </Icon>
                    </span> -->
                    <span class='icon-box' @click='refreshShopProductList'>
                        <Icon color='#606266'>
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <el-tabs v-model='activeName' @tab-click='handleClick' v-if='countSaleStatus'>
                <el-tab-pane label='' name='null'></el-tab-pane>
                <el-tab-pane :label="`全部 (
                    ${countSaleStatus['status_0']
                    + countSaleStatus['status_1']
                    + countSaleStatus['status_2']
                    + countSaleStatus['status_3']
                    + countSaleStatus['status_4']
                } )`" name='all'></el-tab-pane>
                <el-tab-pane :label="`已下架 ( ${countSaleStatus['status_0']} )`" name='soldUutStock'></el-tab-pane>
                <el-tab-pane :label="`在售中 ( ${countSaleStatus['status_1']} )`" name='onSale'></el-tab-pane>
                <el-tab-pane :label="`仓库中 ( ${countSaleStatus['status_2']} )`" name='warehouse'></el-tab-pane>
                <el-tab-pane :label="`审核中 ( ${countSaleStatus['status_3']} )`" name='audit'></el-tab-pane>
                <el-tab-pane :label="`未过审 ( ${countSaleStatus['status_4']} )`" name='untried'></el-tab-pane>
                <el-tab-pane :label="`库存警戒  ( ${countSaleStatus['status_5']} )`"
                             name='inventoryAlert'></el-tab-pane>
                <el-tab-pane :label="`已售罄 ( ${countSaleStatus['status_6']} )`" name='soldOut'></el-tab-pane>


            </el-tabs>
            <!-- 列表数据 -->
            <el-table :data='shopProductList' row-key='id' size='small' height='100%'
                      @selection-change='handleSelectionChange'>
                <el-table-column align='center' type='selection' width='50'></el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='left' prop='productName' label='商品信息'
                                 width='150'>
                    <template slot-scope='scope'>
                        <div style='text-align: left'>名称：{{ scope.row.productName }}</div>
                        <div style='text-align: left'>货号：{{ scope.row.productNumber }}</div>
                        <div style='text-align: left'>类型：{{getProductTypeOne(scope.row.productType)}}</div>
<!--                        <div style='text-align: left' v-if='scope.row.productType == 1'>类型：普通商品</div>-->
<!--                        <div style='text-align: left' v-if='scope.row.productType == 2'>类型：积分商品</div>-->
<!--                        <div style='text-align: left' v-if='scope.row.productType == 3'>类型：秒杀商品</div>-->
<!--                        <div style='text-align: left' v-if='scope.row.productType == 4'>类型：拼团商品</div>-->
<!--                        <div style='text-align: left' v-if='scope.row.productType == 5'>类型：砍价商品</div>-->
<!--                        <div style='text-align: left' v-if='scope.row.productType == 6'>类型：虚拟商品</div>-->
                    </template>
                </el-table-column>
                <el-table-column align='center' label='图片' width='150'>
                    <template slot-scope='scope'>
                        <el-image
                            @click='updateSrcList(scope.row.productPic)'
                            style='width: 80px; height: 80px'
                            :src='scope.row.productPic'
                            :preview-src-list='srcList'
                        ></el-image>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='价格' width='150'>
                    <template slot-scope='scope'>
                        <div style='text-align: left'>
                            商品价格：{{ scope.row.shopPrice }}
                        </div>
                        <div style='text-align: left' v-if="scope.row.supplyPrice">
                            供货价格：{{ scope.row.supplyPrice }}
                        </div>
                        <div style='text-align: left' v-if="scope.row.wholesalePrice">批发价格：{{ scope.row.wholesalePrice }}</div>
                        <div style='text-align: left'>市场价格：{{ scope.row.marketPrice }}</div>
                        <div style='text-align: left'>成本价格：{{ scope.row.costPrice }}</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='商品状态' width='150'>
                    <template slot-scope='scope'>
                        <el-tag type='info' v-if='scope.row.isShow == 0'>{{ computeProductStatus(scope.row.isShow) }}
                        </el-tag>
                        <el-tag type='success' v-if='scope.row.isShow == 1'>{{ computeProductStatus(scope.row.isShow)
                            }}
                        </el-tag>
                        <el-tag type='info' v-if='scope.row.isShow == 2'>{{ computeProductStatus(scope.row.isShow) }}
                        </el-tag>
                        <el-tag type='warning' v-if='scope.row.isShow == 3'>{{ computeProductStatus(scope.row.isShow)
                            }}
                        </el-tag>
                        <el-tag type='danger' v-if='scope.row.isShow == 4'>{{ computeProductStatus(scope.row.isShow)
                            }}
                        </el-tag>
                    </template>
                </el-table-column>
                <!--                <el-table-column :show-overflow-tooltip="true" align="center" label="是否上架" width="150">-->
                <!--                    <template slot-scope="scope">-->
                <!--                        <div>-->
                <!--                            <el-switch-->
                <!--                                :value="true"-->
                <!--                                active-color="#13ce66"-->
                <!--                                inactive-color="#ff4949"-->
                <!--                                v-if="scope.row.isShow == 1"-->
                <!--                                @change="toggleProductIsShow(scope.row.id, scope.row.isShow)"-->
                <!--                            >-->
                <!--                            </el-switch>-->
                <!--                            <el-switch-->
                <!--                                :value="false"-->
                <!--                                active-color="#13ce66"-->
                <!--                                inactive-color="#ff4949"-->
                <!--                                v-if="scope.row.isShow == 0"-->
                <!--                                @change="toggleProductIsShow(scope.row.id, scope.row.isShow)"-->
                <!--                            >-->
                <!--                            </el-switch>-->
                <!--                        </div>-->
                <!--                    </template>-->
                <!--                </el-table-column>-->

                <el-table-column :show-overflow-tooltip='true' align='center' prop='stockSize' label='库存'
                                 width='150'></el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' prop='saleSize' label='已售' width='150'>
                </el-table-column>
                <el-table-column v-if='showShop' :show-overflow-tooltip='true' align='left' prop='productName'
                                 label='所属店铺' width='150'>
                    <template slot-scope='scope'>
                        <div v-if='scope.row.shop' style="color: rgb(64, 158, 255)" @click="handleMallShop(scope.row)">
                            {{ scope.row.shop.shopName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' prop='createTime' label='创建时间'
                                 width='150'>
                </el-table-column>

                <el-table-column fixed='right' align='center' label='操作' width='250'>
                    <!--                    <template slot-scope="scop">-->
                    <!--                        <div class="operation">-->
                    <!--                            <div @click="checkShopProduct(scop.row.id)">-->
                    <!--                                <Icon size="16">-->
                    <!--                                    <Eye24Regular />-->
                    <!--                                </Icon>-->
                    <!--                                <span class="operation-label">查看</span>-->
                    <!--                            </div>-->
                    <!--                            <div @click="editShopProduct(scop.row.id)">-->
                    <!--                                <Icon size="16">-->
                    <!--                                    <Edit24Regular />-->
                    <!--                                </Icon>-->
                    <!--                                <span class="operation-label">修改</span>-->
                    <!--                            </div>-->
                    <!--                            <div @click="deleteShopProduct(scop.row.id)">-->
                    <!--                                <Icon size="16" style="color: red">-->
                    <!--                                    <Delete24Regular />-->
                    <!--                                </Icon>-->
                    <!--                                <span class="operation-label" style="color: red">删除</span>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </template>-->
                    <template slot-scope='scop'>
                        <div class='operation'>
                           <div v-if='scop.row.isShow == 3 && showShop == 1'>
                               <el-button type="primary" size="small" @click="checkProduct(scop.row.id)">审核</el-button>
                           </div>
                            <div @click='checkShopProduct(scop.row.id)'>
                                <Icon size='16'>
                                    <Eye24Regular />
                                </Icon>
                                <span class='operation-label'>查看</span>
                            </div>
                            <div @click='editShopProduct(scop.row.id)'>
                                <Icon size='16'>
                                    <Edit24Regular />
                                </Icon>
                                <span class='operation-label'>修改</span>
                            </div>
                            <el-dropdown size='small'>
                                <span class='el-dropdown-link'>
                                    更多<i class='el-icon-arrow-down el-icon--right'></i>
                                </span>
                                <el-dropdown-menu slot='dropdown'>
                                    <el-dropdown-item
                                        v-if="scop.row.isShow == 1"
                                    >
                                        <div @click="changeProductStatus(scop.row.id,0)">
                                            <Icon size='16' style='color: #409eff'>
                                                <Edit24Regular />
                                            </Icon>
                                            <span class='operation-label' style='color: #409eff'>下架</span>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                        v-if="scop.row.isShow == 0 || scop.row.isShow == 2"
                                    >
                                        <div @click="changeProductStatus(scop.row.id,1)">
                                            <Icon size='16' style='color: #409eff'>
                                                <Edit24Regular />
                                            </Icon>
                                            <span class='operation-label' style='color: #409eff'>上架</span>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                        v-if="scop.row.isShow == 0 || scop.row.isShow == 1"
                                    >
                                        <div @click="changeProductStatus(scop.row.id,2)">
                                            <Icon size='16' style='color: #409eff'>
                                                <Edit24Regular />
                                            </Icon>
                                            <span class='operation-label' style='color: #409eff'>仓库</span>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                        v-if="scop.row.isShow != 1"
                                    >
                                        <div @click='deleteShopProduct(scop.row.id)'>
                                            <Icon size='16' style='color: red'>
                                                <Delete24Regular />
                                            </Icon>
                                            <span class='operation-label' style='color: red'>删除</span>
                                        </div>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='sizeChange'
                    @current-change='currentChange'
                    :current-page.sync='currentPage'
                    :page-sizes='[10, 20, 50, 100]'
                    :page-size='pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    :total='totalNum'
                    background
                    :pager-count='7'
                >
                </el-pagination>
            </div>

            <el-dialog :title='shopProductStates[shopProductState]' :visible.sync='showDialog' width='80%'
                       @close='closeDialog'>
                <ProductEdit
                    ref='ProductEdit'
                    @closeDialog='closeDialog'
                    :shopProductState='shopProductState'
                    :shopProduct='shopProduct'
                ></ProductEdit>
                <div slot='footer' class='flex justify-end'>
                    <el-button @click='closeDialog'>关闭</el-button>
                    <el-button type='primary' @click='submitForm' v-if="shopProductState != 'check'">确定</el-button>
                </div>
            </el-dialog>

            <el-dialog
                title="提示"
                :visible.sync="checkProductDialogVisible"
                width="35%"
                :before-close='closeCheckProductDialog'>
                <el-form :rules='rules' :model="checkProductForm" ref="checkProductForm">
                    <el-form-item label="商品审核" prop="checkProductStatus">
                        <el-radio-group v-model="checkProductForm.checkProductStatus">
                            <el-radio label="1">通过</el-radio>
                            <el-radio label="0">拒绝</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="checkProductForm.checkProductStatus==='0'" label="拒绝原因" prop="refuseReason">
                        <el-input
                            placeholder="请输入拒绝原因"
                            type="textarea"
                            size="small"
                            :rows="3"
                            v-model="checkProductForm.refuseReason"
                            style="width: 80%;"
                        ></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="closeCheckProductDialog">取 消</el-button>
                    <el-button type="primary" @click="editCheckProduct()">确 定</el-button>
                </span>
            </el-dialog>
        </div>
        <ProductImport
            v-if="productImportVisible"
            :visible="productImportVisible"
            title="导入供应链商品"
            @close="closeImportDialog"
        ></ProductImport>
        <mallShopDialog
            v-if="mallShopVisible"
            :visible="mallShopVisible"
            :mallShopId="mallShopId"
            @close="mallShopVisible = false"
        ></mallShopDialog>

        <!-- 批量修改弹框 -->
        <el-dialog
            title="批量修改"
            :visible.sync="batchEditDialogVisible"
            width="30vw"
            @close="handleBatchEditDialogClose"
        >
            <el-form :model="batchEditForm" ref="batchEditForm" label-width="100px">
                <el-form-item label="所属店铺" prop="shopId">
                    <GridSelectShop
                        style="width: 200px"
                        title="选择店铺"
                        labelName="shopName"
                        labelValue="id"
                        :value="batchEditForm.shopId"
                        :limit="1"
                        size="small"
                        @getValue="getValueShopIdToEdit"
                        :columns="SHOP_code"
                        :searchs="SHOP_search"
                        dataListUrl="/mall/shop/findList"
                        entityBeanName="mallShop"
                        queryEntityUrl="/mall/shop/get"
                    >
                    </GridSelectShop>
                </el-form-item>
                <el-form-item label="商品分类" prop="shopCategoryId">
                    <el-select style="width: 200px" v-model="batchEditForm.shopCategoryId" placeholder="请选择" clearable size="small">
                        <el-tree node-key="id" :default-expanded-keys="expandss" :data="shopCategoryIds" :props="treeProps">
                            <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                                <el-option :label="node.label" :value="data.id"> </el-option>
                            </div>
                        </el-tree>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品类目" prop="categoryId">
			    <el-select style="width: 200px" v-model="batchEditForm.categoryId" placeholder="请选择" clearable size="small">
			        <el-tree node-key="id" :default-expanded-keys="expands" :data="shopProductCategoryList" :props="treeProps">
			            <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
			                <el-option :label="node.label" :value="data.id" :disabled="data.grade === 1 || data.grade === 2"></el-option>
			            </div>
			        </el-tree>
			    </el-select>
			</el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleBatchEditDialogClose">取消</el-button>
                <el-button type="primary" @click="batchEditConfirm">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import {
    exprotExcel,
    importTemplate,
    importDate,
    get,
    post,
    postJson,
    put,
    deleteFun,
    upload
} from '@/utils/request.js';
import WangEditor from '@/components/common/wangeditor';
import ProductEdit from './ProductEdit.vue';
import GridSelectShop from '@/components/gridselect/gidselect.vue';
import { SHOP, SHOP_SEARCH } from '@/utils/constant';
import ProductImport from '@/components/shop/ProductImport/ProductImport.vue';
import mallShopDialog from '@/components/shop/mallShopDialog.vue';

export default {
    components: {
        GridSelectShop,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        WangEditor,
        ProductEdit,
        ProductImport,
        mallShopDialog
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopProductList();
                this.getShopProductList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopProductList();
                this.getShopProductList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            SHOP_code: SHOP,
            SHOP_search: SHOP_SEARCH,
            warnStock: '',//库存警戒
            saleMode: 1,
            status: '',
            saleModeTwo: '',
            showShop: 0,
            showStatus: 0,
            productStatusEnumList: [], //商品状态枚举
            checkProductDialogVisible: false, //审核商品弹窗
            checkProductForm: {
                id: '',
                checkProductStatus: '', // 审核状态
                refuseReason: ''
            },

            queryForm: {
                id: '', //Id
                productName: '', //商品名称
                productNumber: '', //商品货号R
                shopPrice: '', //本店价格
                shopId: '', //店铺
                miniShopPrice: '', //商品最小价格
                maxShopPrice: '', //商品最大价格
                miniStock: '', //商品最小库存
                maxStock: '', //商品最大库存
                marketPrice: '', //市场价格
                costPrice: '', //成本价
                supplyPrice: '', //提供价格
                productPic: '', //图片
                productVideo: '', //视频地址
                productAlbum: '', //产品相册
                productContent: '', //详细描述（内容）
                productType: '', //商品类型
                categoryId: '', //产品分组id
                sort: '', //排序
                isShow: '', //是否显示
                stockSize: '', //库存数量
                supplyStartSize: '',
                supplyEndSize: '',
                saleSize: '', //产品销量
                isFreightFree: '', //是否免运费 1：是 0：否
                freightPrice: '', //运费
                createUserId: '', //创建人
                createTime: '', //创建时间
                updateUserId: '', //更新人
                updateTime: '', //更新时间
                deleteFlag: '', //是否删除
                productPosition: '', //商品定位
            },
            dialogImageUrl: '', //
            dialogVisible: false,
            disabled: false,
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopProductState: 'add',
            treeProps: {
                children: 'children',
                label: 'categoryName'
            },
            shopProductStates: {
                add: '新建商品',
                check: '查看商品',
                edit: '修改商品'
            },

            shopProductCategoryList: [], //商品分类
            isShowList: [], //是否上架
            multipleSelection: [],
            shopProductList: [],
            shopProduct: {},
            btnLoading: false,
            rules: {
                productName: [{ required: true, message: '商品名称不能为空', trigger: 'blur' }],
                author: [{ required: true, message: '编写者不能为空', trigger: 'blur' }],
                productNumber: [{ required: true, message: '商品货号不能为空', trigger: 'blur' }],
                shopPrice: [{ required: true, message: '本店价格不能为空', trigger: 'blur' }],
                categoryId: [{ required: true, message: '商品分类不能为空', trigger: 'blur' }],
                stockSize: [{ required: true, message: '库存数量不能为空', trigger: 'blur' }],
                isFreightFree: [{ required: true, message: '是否免运费 1：是 0：否不能为空', trigger: 'blur' }],
                isShow: [{ required: true, message: '是否上架不能为空', trigger: 'blur' }],
                sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                supplySize: [{ required: true, message: '发行量不能为空', trigger: 'blur' }],
                saleSize: [{ required: true, message: '已售不能为空', trigger: 'blur' }],
                saleTime: [{ required: true, message: '预售时间不能为空', trigger: 'blur' }],
                productPic: [{ required: true, message: '缩略图不能为空', trigger: 'blur' }],
                freightPrice: [{ required: true, message: '运费不能为空', trigger: 'blur' }],
                saleMode: [{ required: true, message: '销售模式不能为空', trigger: 'blur' }],
                fileType: [{ required: true, message: '文件类型不能为空', trigger: 'blur' }],
                objFile: [{ required: true, message: 'obj文件不能为空', trigger: 'blur' }],
                mtlFile: [{ required: true, message: 'mtl文件不能为空', trigger: 'blur' }],
                pictureFile: [{ required: true, message: 'pic文件不能为空', trigger: 'blur' }],
                productAudio: [{ required: true, message: '音频文件不能为空', trigger: 'blur' }],
                productVideo: [{ required: true, message: '视频文件不能为空', trigger: 'blur' }],
                productPhoto: [{ required: true, message: '商品图片不能为空', trigger: 'blur' }],
                buyLimit: [{ required: true, message: '限购数量不能为空', trigger: 'blur' }],
                checkProductStatus: [{ required: true, message: '审核状态不能为空', trigger: 'blur' }],
                refuseReason: [{ required: true, message: '拒绝原因不能为空', trigger: 'blur' }]
            },
            fileList: [],
            list: '',
            header: {
                token: localStorage.getItem('token')
            },
            auditStatus: [],
            srcList: [''],//大图预览
            productTypeEnumList: [],//商品类型枚举
            activeName: 'all',// tabs
            countSaleStatus: {
                'status_1': 0,
                'status_2': 0,
                'status_3': 0,
                'status_4': 0
            },// 获取商品状态的数量
            productImportVisible: false,

            mallShopVisible: false,
            mallShopId: '',
            treeProps: {
                children: 'children',
                label: 'categoryName'
            },
            batchEditDialogVisible: false,
            batchEditForm: {
                ids: [],
                shopId: '',
                categoryId: '',
                shopCategoryId: ''
            },
            shopCategoryIds: [],
            expandss: [],
            expands: [],
            shopProductCategoryList: [],
            productPositionList: []
        };
    },
    created() {
        this.getStockAlertConfig();
        this.getCountSaleStatus();
        this.getIsShowList();
        this.getAuditStatus();
        this.getProductType();
        this.getShopProductCategoryList();
        this.getShopProductList();
        this.getProductStatusEnum();
        this.getShowShop();
        this.getShowStatus();
        this.getSaleMode();
        this.getProductPositionList();
    },
    onload() {
        console.log(localStorage.getItem('token'));
    },
    mounted() {
        this.getClassification();
    },
    methods: {
        getProductPositionList(){
            get('/shop/product/productPositionEnum').then((res) => {
                if (res.success && res.code == 200) {
                    this.productPositionList = res.enumList || [];
                }
            });
        },
        getUserAuditStatus(auditStatus) {
            for (const index in this.auditStatus) {
                if (this.auditStatus[index].key == auditStatus) {
                    return this.auditStatus[index].value;
                }
            }
        },
        getAuditStatus() {
            get('/mpp/utils/getEnum', { enumType: 'audit_status' }).then((res) => {
                this.auditStatus = res.enumList;
            });
        },
        getSaleMode(id){
            let obj = {}
            if(id){
                obj.shopId = id
            }
            get('/mall/shop/getSaleMode', obj).then((res)=>{
                if(res.success){
                    if(res.saleMode == 0){
                        this.saleModeTwo = res.saleMode
                        this.saleMode = ''
                        get('/mall/shop/getSaleMode', {shopId: this.shopProduct.shopId}).then((res)=>{
                            if(res.success){
                                if(res.saleMode == 0){
                                    this.saleModeTwo = res.saleMode
                                    this.saleMode = ''
                                }else{
                                    this.saleMode = res.saleMode
                                }
                            }
                        })
                    }else{
                        this.saleMode = res.saleMode
                    }
                }
            })
        },
        updateSrcList(src) {
            this.srcList[0] = src;
        },

        //生成货号，货号不能为空
        genProductNum() {
            let dateTime;
            let yy = new Date().getFullYear();
            let mm = new Date().getMonth() + 1;
            let dd = new Date().getDate();
            let hh = new Date().getHours();
            let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
            let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
            dateTime = yy + '' + mm + '' + dd + '' + hh + '' + mf + '' + ss;
            this.shopProduct.productNumber = dateTime;
        },
        handleRemove(file, fileList) {
            var str = [];
            for (let i = 0; i < fileList.length; i++) {
                str.push(fileList[i].url);
            }
            this.list = str.join('|');
        },
        handlePreview(file) {
            console.log(file);
        },
        //上传成功
        handleSuccess(response, file, fileList) {
            var str = [];
            for (let i = 0; i < fileList.length - 1; i++) {
                str.push(fileList[i].url);
            }
            str.push(file.response.url);
            this.list = str.join('|');
        },
        getShopProductCategoryList(query = {}) {
            this.loading = true;
            get(`/shop/productcategory/findAllAsTree`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopProductCategoryList = res.treeData;
                }
            });
        },
        getIsShow(isShow) {
            console.log(isShow);
            for (const index in this.isShowList) {
                if (this.isShowList[index].key == isShow) {
                    return this.isShowList[index].value;
                }
            }
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopProductList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopProductList = [];
        },

        //点击是否显示发行量
        toggleProductIsSupply(productId, supply) {
            const shopProduct = {
                id: productId,
                canSupply: supply == 1 ? 0 : 1
            };
            delete shopProduct.category;
            post(`/shop/product/edit`, { ...shopProduct }).then((res) => {
                if (res.success) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                    this.resetShopProductList();
                    this.getShopProductList();
                }
            });
        },
        //点击是否上架
        toggleProductIsShow(productId, show) {
            const shopProduct = {
                id: productId,
                isShow: show == 1 ? 0 : 1
            };
            delete shopProduct.category;
            postJson(`/shop/product/edit`, { ...shopProduct }).then((res) => {
                if (res.success) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                    this.resetShopProductList();
                    this.getShopProductList();
                }
            });
        },
        submitForm() {
            if (this.shopProductState == 'add') {
                this.$refs.shopProductForm.validate((valid) => {
                    if (valid) {
                        post(`/shop/product/add`, { ...this.shopProduct }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopProductList();
                                this.getShopProductList();
                                this.showDialog = false;
                            }
                        });
                    }
                });
            } else if (this.shopProductState == 'edit') {
                this.$refs.ProductEdit.submitForm();
            }
        },
        closeDialog(val) {
            this.shopProduct = {};
            // this.$refs.contentEditor.init('');
            this.showDialog = false;
            this.$refs.ProductEdit.closeDialog();

            if (val) {
                // this.resetShopProductList();
                this.getShopProductList();
            }
        },
        addShopProduct() {
            //this.getShopProductCategoryList();

            this.showDialog = true;
            this.shopProductState = 'add';
        },
        checkShopProduct(shopProductId) {
            //this.getShopProductCategoryList();
            this.currentShopProductId = shopProductId;
            this.getShopProductById();
            this.showDialog = true;
            this.shopProductState = 'check';
        },
        editShopProduct(shopProductId) {
            //this.getShopProductCategoryList();
            if (shopProductId) {
                this.currentShopProductId = shopProductId;
                this.getShopProductById();
            } else {
                this.shopProduct = { ...this.shopProduct, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopProductState = 'edit';
        },
        editShopProductStatus() {
            let ids = this.multipleSelection.map((shopProduct) => shopProduct.id).join(',');
            console.log({ ids });
            this.$confirm('确定要修改所选项状态吗?', '提示', {
                type: 'warning'
            })
                .then(() => {
                    post(`/shop/product/editBatchStatus`, { ids, status: this.status }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopProductList();
                            this.getShopProductList();
                        }
                    });
                })
                .catch(() => {
                });
        },
        handleImportDialog() {
            this.productImportVisible = true
        },
        closeImportDialog(data) {
            this.productImportVisible = false
            if(data?.confirm) {
                this.refreshShopProductList()
            }
        },
        deleteShopProduct(shopProductId) {
            let ids = '';
            if (shopProductId) {
                ids = shopProductId;
            } else {
                ids = this.multipleSelection.map((shopProduct) => shopProduct.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/product/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopProductList();
                            this.getShopProductList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshShopProductList() {
            this.resetShopProductList();
            this.getShopProductList();
        },
        getShopProductList(query = {}) {
            this.loading = true;
            get(`/shop/product/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopProductList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getShopProductById() {
            this.loading = true;
            this.shopProduct = {};
            this.fileList = [];
            this.list = '';
            get(`/shop/product/get`, { id: this.currentShopProductId }).then((res) => {
                // this.$refs.contentEditor.init('');
                if (res.success && res.code == 200) {
                    this.shopProduct = { ...this.shopProduct, ...res.shopProduct };
                    this.$forceUpdate();
                    // this.$refs.contentEditor.init(this.shopProduct.productContent);
                    this.loading = false;
                    // if (res.shopProduct.productAlbum) {
                    //     let str = res.shopProduct.productAlbum;
                    //     var list = str.split('|');
                    //     this.fileList = list.map((item) => {
                    //         return {
                    //             name: item,
                    //             url: item
                    //         };
                    //     });
                    // }
                }
            });
        },
        /**
         * 导出出岗位信息
         */
        exportShopProductList() {
            this.btnLoading = true;
            exprotExcel(`/shop/product/export`, this.shopProduct, this.btnLoading);
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/shop/product/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            importDate(`/shop/product/importData`, formData);
            this.refreshShopProductList();
        },
        //上传缩略图
        uploadAvatar(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(`/mpp/image/upload`, formData).then((res) => {
                if (res.success) {
                    this.shopProduct.productPic = res.url;
                    console.log(this.shopProduct.productPic);
                }
            });
        },
        //静态图片，音频，视频，3D效果图
        uploadFile(params) {
            const file = params.file;
            console.log(file.type);
            const formData = new FormData();
            formData.append('file', file);
            upload(`/mpp/image/upload`, formData).then((res) => {
                if (res.success && res.code == 200) {
                    if (this.shopProduct.fileType == 1) {
                        this.shopProduct.productPhoto = res.url; //图片
                    } else if (this.shopProduct.fileType == 2) {
                        this.shopProduct.productPhoto = res.url; //图片
                    } else if (this.shopProduct.fileType == 3) {
                        this.shopProduct.productAudio = res.url; //音频
                    } else if (this.shopProduct.fileType == 4) {
                        this.shopProduct.productVideo = res.url; //视频
                    } else if (this.shopProduct.fileType == 5) {
                        if (file.type.search('obj') || file.type.search('OBJ')) {
                            this.shopProduct.objFile = res.url; //3D效果图 obj文件
                        } else if (file.type.search('mtl') || file.type.search('MTL')) {
                            this.shopProduct.mtlFile = res.url; //3D效果图 mtl文件
                        } else {
                            this.shopProduct.pictureFile = res.url; //3D效果图 png文件
                        }
                    }
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        showClose: true,
                        duration: 2000
                    });
                }
            });
        },
        //证书图片
        uploadCert(params) {
            const file = params.file;
            console.log(file.type);
            const formData = new FormData();
            formData.append('file', file);
            upload(`/mpp/image/upload`, formData).then((res) => {
                if (res.success && res.code == 200) {
                    console.log(res.url);
                    this.shopProduct.certPic = res.url;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        showClose: true,
                        duration: 2000
                    });
                }
            });
        },
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 50MB!');
            }
            return isLt2M;
        },
        //是否上架
        getIsShowList() {
            get(`/mpp/utils/getEnum`, { enumType: `yes_no` }).then((res) => {
                if (res.success) {
                    this.isShowList = res.enumList;
                }
            });
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopProductList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopProductList();
        },
        resetQueryForm() {
            this.queryForm.id = '';
            this.queryForm.productName = '';
            this.queryForm.productNumber = '';
            this.queryForm.shopPrice = '';
            this.queryForm.shopId = '';
            this.queryForm.miniShopPrice = '';
            this.queryForm.maxShopPrice = '';
            this.queryForm.marketPrice = '';
            this.queryForm.miniStock = '';
            this.queryForm.maxStock = '';
            this.queryForm.costPrice = '';
            this.queryForm.supplyPrice = '';
            this.queryForm.productPic = '';
            this.queryForm.productVideo = '';
            this.queryForm.productAlbum = '';
            this.queryForm.productContent = '';
            this.queryForm.categoryId = '';
            this.queryForm.sort = '';
            this.queryForm.isShow = '';
            this.queryForm.stockSize = '';
            this.queryForm.supplyStartSize = '';
            this.queryForm.supplyEndSize = '';
            this.queryForm.saleSize = '';
            this.queryForm.isFreightFree = '';
            this.queryForm.freightPrice = '';
            this.queryForm.createUserId = '';
            this.queryForm.updateTime = '';
            this.queryForm.deleteFlag = '';
            this.getShopProductList();
        },
        productRepairPush(id) {
            get('/mpp/mq/productRepairPush', { productId: id }).then((res) => {
                if (res.success) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                }
            });
        },
        inputClick(url) {
            window.open(url);
        },
        getValueShopId(value) {
            this.queryForm.shopId = value;
        },

        // tabs
        handleClick(tab) {
            switch (tab.$options.propsData.name) {
                case 'all':
                    this.queryForm.isShow = '';
                    this.queryForm.miniStock = '';
                    this.queryForm.maxStock = '';
                    this.getShopProductList();
                    break;
                case 'onSale':
                    this.queryForm.isShow = 1;
                    this.queryForm.miniStock = '';
                    this.queryForm.maxStock = '';
                    this.getShopProductList();
                    break;
                case 'inventoryAlert':
                    this.queryForm.isShow = 1;
                    this.queryForm.miniStock = 1;
                    this.queryForm.maxStock = this.warnStock;
                    this.getShopProductList();
                    break;
                case 'soldOut':
                    this.queryForm.isShow = 1;
                    this.queryForm.miniStock = 0;
                    this.queryForm.maxStock = 0;
                    this.getShopProductList();
                    break;
                case 'soldUutStock':
                    this.queryForm.isShow = 0;
                    this.queryForm.miniStock = '';
                    this.queryForm.maxStock = '';
                    this.getShopProductList();
                    break;
                case 'warehouse':
                    this.queryForm.isShow = 2;
                    this.queryForm.miniStock = '';
                    this.queryForm.maxStock = '';
                    this.getShopProductList();
                    break;
                case 'audit':
                    this.queryForm.isShow = 3;
                    this.queryForm.miniStock = '';
                    this.queryForm.maxStock = '';
                    this.getShopProductList();
                    break;
                case 'untried':
                    this.queryForm.isShow = 4;
                    this.queryForm.miniStock = '';
                    this.queryForm.maxStock = '';
                    this.getShopProductList();
                    break;
            }

        },

        // 获取产品分类枚举
        getProductType() {
            get('/mpp/utils/getEnum', {
                enumType: 'product_type'
            }).then((res) => {
                if (res.success) {
                    this.productTypeEnumList = res.enumList;
                    console.log('this.ProductTypeEnumList', this.ProductTypeEnumList);
                }
            });
        },

        getProductTypeOne(keys){
            for (let productTypeEnumListKey in this.productTypeEnumList) {
                if(this.productTypeEnumList[productTypeEnumListKey].key == keys){
                    return this.productTypeEnumList[productTypeEnumListKey].value
                }
            }
        },

        // 获取商品状态的数量
        getCountSaleStatus() {
            get('/shop/product/countSaleStatus').then((res) => {
                if (res.success) {
                    this.countSaleStatus = res.map;
                }
            });
        },

        // 获取商品状态枚举
        getProductStatusEnum() {
            get('/mpp/utils/getEnum', {
                enumType: 'product_status'
            }).then((res) => {
                if (res.success) {
                    this.productStatusEnumList = res.enumList;
                }
            });
        },

        // 计算商品状态
        computeProductStatus(type) {
            for (let i = 0; i < this.productStatusEnumList.length; i++) {
                if (this.productStatusEnumList[i].key == type) {
                    return this.productStatusEnumList[i].value;
                }
            }
        },

        // 获取库存警戒配置
        getStockAlertConfig() {
            get('/mpp/utils/getWarnStock').then((res) => {
                if (res.success) {
                    this.warnStock = res.warnStock;
                }
            });
        },

        // 获取showShop
        getShowShop() {
            get('/mall/shop/getShowShop').then((res) => {
                if (res.success) {
                    this.showShop = res.showShop;
                }
            });
        },

        //获取showStatus
        getShowStatus() {
            get('/shop/product/getShowStatus').then((res) => {
                if (res.success) {
                    this.showStatus = res.showStatus;
                }
            });
        },


        // 关闭审核商品弹窗
        closeCheckProductDialog() {
            this.checkProductDialogVisible = false
            this.checkProductForm = {
                id: '',
                checkProductStatus: '',
                refuseReason: ''
            }
        },

        handleMallShop(row) {
            let { shopId } = row
            this.mallShopVisible = true
            this.mallShopId = shopId
        },

        // 审核商品
        checkProduct(id){
            this.checkProductDialogVisible = true
            this.checkProductForm.id = id
        },
        editCheckProduct(id){
            console.log('valid', this.$refs.checkProductForm)
            this.$refs.checkProductForm.validate((valid) => {
                if (valid) {
                    let params = {
                        id: this.checkProductForm.id,
                        status: this.checkProductForm.checkProductStatus == '1' ? 1 : 4    // 同意后的状态 : 拒绝的状态
                    }
                    if(this.checkProductForm.checkProductStatus === '0') {
                        params.refuseReason = this.checkProductForm.refuseReason
                    }
                    post('/shop/product/editStatus', params).then((res)=>{
                        if(res.success){
                            this.$message({
                                message: res.msg,
                                type:'success',
                                duration: 2000
                            });
                            this.getShopProductList();
                            this.getCountSaleStatus();
                            this.closeCheckProductDialog();
                        } else {
                            this.$message({
                                message: res.msg,
                                type:'error',
                            });
                        }
                    })
                }
            })
        },

        // 修改商品状态
        changeProductStatus(id, status) {
            this.$confirm(`商品将设置为${this.productStatusEnumList[status].value}`, '提示', {
                type: 'warning'
            }).then(()=>{
                post('/shop/product/editStatus', {
                    id: id,
                    status: status
                }).then((res) => {
                    if (res.success) {
                        this.$message({
                            message: res.msg,
                            type:'success',
                            duration: 2000
                        });
                        this.getShopProductList();
                        this.getCountSaleStatus();
                    } else {
                        this.$message({
                            message: res.msg,
                            type:'error',
                            duration: 2000
                        });
                    }
                });
            }).catch(()=>{})
        },
        handleBatchEditDialog() {
            const ids = this.multipleSelection.map((shopProduct) => shopProduct.id);
            console.log('ids============>', ids);
            this.batchEditDialogVisible = true;
            this.batchEditForm.ids = ids;
        },
        handleBatchEditDialogClose() {
            this.batchEditDialogVisible = false;
            this.batchEditForm = {
                ids: [],
                shopId: '',
                categoryId: '',
                shopCategoryId: ''
            }
        },
        getValueShopIdToEdit(val) {
            this.batchEditForm.shopId = val;
            this.batchEditForm.shopCategoryId = '';
            get('/shop/shopproductcategory/findAllAsTree',{ shopId: val }).then((res)=>{
                if(res.success){
                    this.shopCategoryIds = res.treeData;
                    res.treeData.forEach((element) => {
                        this.expandss.push(element.id);
                    });
                }
            })
        },
        getClassification() {
            get(`/shop/productcategory/findAllAsTree`).then((res) => {
                if (res.success && res.code == 200) {
                    this.shopProductCategoryList = res.treeData.map(item1 => {
                        item1.children = item1.children.map(item2 => ({ ...item2, grade: 2 }))
                        return { ...item1, grade: 1 }
                    });
                    res.treeData.forEach((element) => {
                        this.expands.push(element.id);
                    });
                }
            });
        },
        batchEditConfirm() {
            postJson('/shop/product/editBatch', this.batchEditForm).then((res) => {
                if (res.success) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                    this.handleBatchEditDialogClose();
                    this.getShopProductList();
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
    }
};
</script>

<style lang='scss' scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 200px;
    height: 200px;
    display: block;
}

.disUoloadSty .el-upload--picture-card {
    display: none;
}

.classInput {
    width: 200px;
}

.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
}

.el-icon-arrow-down {
    font-size: 12px;
}

::v-deep .el-dropdown {
    font-size: 12px;
    color: #409eff;
}

</style>
